module.exports = __webpack_public_path__ + "static/media/bg-superiority-1.050cee88.png";